"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var shared;
        (function (shared) {
            var userAudit;
            (function (userAudit) {
                class InitArgs {
                    constructor() {
                        this.forProviderId = 0;
                    }
                }
                let _initArgs;
                let _dataTableUserAudit = null;
                function init(args) {
                    _initArgs = args;
                    initUserAuditTable();
                }
                userAudit.init = init;
                function initUserAuditTable() {
                    _dataTableUserAudit = appn.dataTable.create('.userAuditTable', {
                        sDom: appn.dataTable.genSDom(0, 0, 1),
                        scrollX: '100%',
                        sAjaxSource: '../UserAuditDataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')), appn.dataTable.getStateOrDefault('sCustom_1', _initArgs.forProviderId));
                        },
                        aLengthMenu: [10, 25, 50, 100],
                        iDisplayLength: 50,
                        aaSorting: [[4, 'desc']],
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(T('Include Invited Users'), 'saveMeState', 'sCustom_0'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where any column contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTableUserAudit.fnDraw(false);
                            }, function () {
                                _dataTableUserAudit.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
                function getDtColConfiguration() {
                    return [
                        { bSortable: true, sWidth: '10%' },
                        { bSortable: true, sWidth: '25%' },
                        { bSortable: true, sWidth: '10%' },
                        { bSortable: true, sWidth: '10%' },
                        { bSortable: true, sWidth: '10%' },
                        { bSortable: true, sWidth: '10%' },
                        { bSortable: true, sWidth: '25%' }
                    ];
                }
            })(userAudit = shared.userAudit || (shared.userAudit = {}));
        })(shared = views.shared || (views.shared = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
